import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  orderDetails: null,
  sixmnthWarehsList: []
};

export default function UserPlanSbsrptnWarehseReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case actionTypes.FETCH_WAREHOUSESPLAN_SUCCESS_ACTION:
      return {
        ...state,
        listwarehousePlan: action.payload.rows,
        countwarehousePlan: action.payload.count,
      };
    case actionTypes.FETCH_WAREHOUSESUBLIST_INIT_ACTION:
      return {
        ...state,
        listwarehousesub: [],
      };
    case actionTypes.FETCH_WAREHOUSESUBLIST_SUCCESS_ACTION:
      return {
        ...state,
        listwarehousesub: action.payload.rows,
      };
    case actionTypes.FETCH_WAREHOUSEPAYMENTMODE_SUCCESS_ACTION:
      return {
        ...state,
        warehousePaymentmode: action.payload.rows,
      };
    case actionTypes.FETCH_WAREHOUSESPROVIDER_SUCCESS_ACTION:
      return {
        ...state,
        warehouseproviderList: action.payload,
      };
    case actionTypes.FETCH_OTHERUSERS_SUCCESS_ACTION:
      return {
        ...state,
        otherUsersList: action.payload.rows,
        countUsersList: action.payload.count,
      };
    case actionTypes.CREATE_RAZORPAYORDER_ACTION:
      return {
        ...state,
        processing: true,
      };
    case actionTypes.CREATE_RAZORPAYORDER_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        orderDetails: action.payload,
      };
    case actionTypes.WAREHOUSESUBSCRIBE_PLAN_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        orderDetails: null,
      };
    case actionTypes.FETCH_SIXMNTH_WAREHOUSESUB_SUCCESS_ACTION:
      return {
        ...state,
        processing: false,
        sixmnthWarehsList: action.payload.rows,
      };

      case actionTypes.FETCH_APPCONFIG_SUCCESS:
        return{
          ...state,
          appConfig:action.payload
        }
    default:
      return {
        ...state,
      };
  }
}
